export default __webpack_public_path__ + "static/media/0xff88434e29d1e2333ad6baa08d358b436196da6b.da90e0cf.png";